__turbopack_context__.v({
  "control": "SVqg6G_control",
  "inline": "SVqg6G_inline",
  "root": "SVqg6G_root",
  "subtitle": "SVqg6G_subtitle",
  "titleColumn": "SVqg6G_titleColumn",
});
